import type { AppFooterProps } from '../../types';

export const AppFooter: React.FC<AppFooterProps> = () => {
  return (
    <footer className="border-t bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="h-8 flex items-center justify-center text-[11px] sm:text-xs text-gray-500">
          © Glassshop — All rights reserved. 2025
        </div>
      </div>
    </footer>
  );
};


